import { render, staticRenderFns } from "./VoyageForm.vue?vue&type=template&id=2a208217&scoped=true&"
import script from "./VoyageForm.vue?vue&type=script&lang=js&"
export * from "./VoyageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a208217",
  null
  
)

export default component.exports